import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=c4466bf4&scoped=true&"
import script from "./NewDetails.vue?vue&type=script&lang=js&"
export * from "./NewDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDetails.vue?vue&type=style&index=0&id=c4466bf4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4466bf4",
  null
  
)

export default component.exports